<template>
  <section>
    <div class="table-header">
      <h4>{{ tableTitle }}</h4>
      <p v-if="totalVotes">Total Votes: {{ totalVotes | commas }}</p>
    </div>
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      :dense="mobile"
      :hide-default-footer="true">
      <template #item.party="{item}">
        <span :style="`color: ${partyColor(item.party)};`">{{ item.party }}</span>
      </template>

      <template #item.voteTotal="{item}">
        {{ item.voteTotal | commas }}
      </template>

      <template #item.votePercentage="{item}">
        {{ formattedPercentage(item.votePercentage) }}
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

const props = {
  tableTitle: {
    default: "2016 Presidential",
    required: true,
    type: String,
  },
  totalVotes: {
    default: 0,
    required: true,
    type: Number,
  },
  tableItems: {
    default: [],
    required: true,
    type: Array,
  },
  chamber: {
    default: "senate",
    required: true,
    type: String,
  },
};

const computed = {
  ...mapGetters({
    mobile: "ux/mobile",
  }),
};

const methods = {
  partyColor(partyName) {
    return partyName === "R" ? this.gopColor : this.demColor;
  },
  formattedPercentage(votePercentage) {
    return `${votePercentage.toFixed(1).toString()}%`;
  },
};

export default {
  props,
  computed,
  methods,
  data: () => ({
    gopColor: "#d84b44",
    demColor: "#4575a1",
    tableHeaders: [
      {
        align: "start",
        text: "Candidate",
        value: "name",
      },
      {
        sortable: false,
        text: "Party",
        value: "party",
      },
      {
        text: "Vote Total",
        value: "voteTotal",
      },
      {
        align: "end",
        text: "Vote %",
        value: "votePercentage",
      }
    ],
  }),
};
</script>

<style scoped>
.table-header {
  display: flex;
  justify-content: space-between;
}

.v-data-table /deep/ td {
  min-height: 2.5em;
}
</style>
